/**
 * TODO
 * @packageDocumentation
 */

import { HourglassServiceOptions } from "@cervval.js/client-html5-core/src/services/hourglass.service";
import { RouteErrorJsonResponse, RouteMethods } from "@cervval.js/common-routes";

/**
 * The params object is created when the request errors and then passed to error handlers while no handler returns false (meaning error is handled).
 */
export type ClientRouteErrorHandlerParams<R = unknown> = {
    responseStatus: number, request: RequestParameters, err?: RouteErrorJsonResponse, result: R | undefined
};
/**
 * @returns false if error was handled, true is error still needs to be handled
 * If function returns false, result will be returned as the response value
 * If no handler returns false, the request promise will reject
 */
export type ClientRouteErrorHandler<R = unknown> = (params: ClientRouteErrorHandlerParams<R>) => Promise<boolean>;

/**
 * Standard options passed to route functions.
 */
export interface ClientRouteOptions<HourGlassData = void> {
    urlPrefix?: string;
    method?: RouteMethods;
    showHourGlass?: boolean | HourglassServiceOptions<HourGlassData>;
    timeoutMs?: number;// timeout in milliseconds (0 = unlimited = default)
    onError?: ClientRouteErrorHandler;
    doNotShowDialogOnErrors?: boolean;
    doNotLogErrors?: boolean;
    fileList?: Blob[] | FileList; /** files list to upload files from client to server */
    withCredentials?: CredentialsPolicy; /** option to include cookie or mean to authenticate the request's author */
    abortController?: AbortController;
}

/**
 * Enum to set whether or not we include credentials in request
 */
export enum CredentialsPolicy {
    /**
     * Never include credentials information in CORS requests.
     */
    NO = 1,
    /**
     * Include credentials only for CORS request with same-origin.
     * For XHR, same as NO.
     */
    ONLY_SAME = 2,
    /**
     * Include credentials for all CORS requests.
     */
    ALWAYS = 3
}


export interface JsonRequestParameters {
    url: string;
    method?: RouteMethods | undefined;
    params: unknown;
}

export interface RequestParameters {
    url: string;
    method: RouteMethods;
    contentType: string;
    data: unknown;
}

export const CLIENT_ROUTES_SERVICE = "ClientRoutesService";
export interface ClientRoutesService {

    /**
     * Execute a request on the server.
     * Use this function if you need to control th contentType or request method. Most of the time, you should use callJson.
     */
    call<R = unknown>(request: RequestParameters, options?: ClientRouteOptions): Promise<R | undefined>;

    /**
     * Execute a request on the server with a JSON content type and the default method (eg POST)
     */
    callJson<R = unknown>(request: JsonRequestParameters, options?: ClientRouteOptions): Promise<R | undefined>;

}